import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTrending4"><Path fillRule="evenodd" clipRule="evenodd" d="M3.5 4V18.5H22V20H2V4H3.5ZM14 6H20V12H18.5V8.56066L13 14.0607L11 12.0607L6.75 16.3107L5.68934 15.25L11 9.93934L13 11.9393L17.4393 7.5H14V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrending4;
